// material
import { AppBar, Box, Container, Drawer, Grid, IconButton, Toolbar, Typography } from "@mui/material";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

// import Scrollbar from "../comman/Scrollbar";
// components
// import Scrollbar from "@/components/Scrollbar";

// ----------------------------------------------------------------------

export default function CustomModal({ open, onClose, children, title, subTitle, anchor = 'right', width = 60 }) {
  return (
    <Drawer anchor={anchor} open={open} onClose={onClose}>
      <Box sx={{ position:'relative', display: 'flex', flexFlow: 'column' }}>
        <AppBar position="sticky" color="default" elevation={0} sx={{top:0, borderBottom: 1, my:0, borderColor: 'text.disabled' }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              {title && <Typography variant="h6">{title}</Typography>}
              {subTitle && <Typography variant="caption">{subTitle}</Typography>}
            </Box>
            <IconButton size="large" color="inherit" onClick={onClose}>
              <CloseRoundedIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        
        <Grid sx={{width: `${width}vw`}}>
          <Container sx={{ mb: 3, mt:2 }}>
            {children}
          </Container>
        </Grid>
      </Box>
    </Drawer>
  )
}